/**
 * Utilitaires image : capture depuis un flux vidéo et compression avant envoi
 * (max 1600 px, JPEG 80 %) — renvoie une base64 sans le préfixe data:.
 */
import { PHOTO_MAX_PX } from '../constants';

/** Redimensionne un canvas/source vers PHOTO_MAX_PX max et renvoie la base64 JPEG. */
function drawToBase64(source, width, height) {
  const scale = Math.min(1, PHOTO_MAX_PX / Math.max(width, height));
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(width * scale);
  canvas.height = Math.round(height * scale);
  const ctx = canvas.getContext('2d');
  ctx.drawImage(source, 0, 0, canvas.width, canvas.height);
  return canvas.toDataURL('image/jpeg', 0.8).split(',')[1];
}

/** Capture l'image courante d'un élément <video> en base64 compressée. */
export function captureFromVideo(video) {
  return drawToBase64(video, video.videoWidth || 1280, video.videoHeight || 720);
}

/** Convertit un fichier image en base64 compressée (renvoie une Promise). */
export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => resolve(drawToBase64(img, img.width, img.height));
      img.onerror = reject;
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

/** Aperçu data-URL (pour vignette) sans compression forte. */
export function fileToPreview(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
